export default "__VITE_ASSET__CgyqGBfV__"